import Modal from 'react-modal';
import React from 'react';
import './NavbarModal.css'

const NavbarModal = ({ isOpen, onRequestClose, state, onStateChange }) => {

    React.useEffect(() => {
        const body = document.querySelector('body');
        if (isOpen) {
            body.style.overflow = 'hidden';
        } else {
            body.style.overflow = 'auto';
        }
    }, [isOpen]);


    const createStateButton = text => {
        var style = state === text ? {opacity: '100%'} : {opacity: '50%'}
        return (<div className='default-text'style={style} onClick={()=>{onStateChange(text); onRequestClose();}}>{text}</div>)
    } 

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onRequestClose}
            ariaHideApp={false}
            shouldCloseOnOverlayClick={true}
            shouldReturnFocusAfterClose={true}
            className='navbar-modal-content'
            overlayClassName='navbar-modal-overlay'
        >
        {createStateButton("MINIMA")}
        <div style={{height: '50px'}}></div>
        {createStateButton("ARTISTS")}
        {createStateButton("WORKS")}
        {createStateButton("CONTACT")}
        </Modal>
    );
};

export default NavbarModal;
